var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"row-style-class":_vm.trClass,"paginationOptions":{
  enabled: true,
  perPage: 10,
  position: 'top',
  perPageDropdown: [5, 10, 15],
  dropdownAllowAll: false,
  nextLabel: 'següent',
  prevLabel: 'anterior',
  rowsPerPageLabel: 'Files per pàgina',
  ofLabel: 'de',
  allLabel: 'All',
},"sortOptions":{
  initialSortBy: {field: 'data_creacio', type: 'desc'}
}},on:{"on-row-click":_vm.viewTicket},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(['usuaris','gestors'].includes(props.column.field))?_c('span',[_c('span',[_vm._v("\n        "+_vm._s(props.row[props.column.field].join(", "))+"\n      ")])]):(['categoria','grup','incidencia'].includes(props.column.field))?_c('span',{attrs:{"title":props.row.categoria.descripcio}},[_vm._v("\n        "+_vm._s(_vm._f("truncate")(props.row[props.column.field],30))+"\n    ")]):(props.column.field == 'estat')?_c('span',{attrs:{"title":props.row.estat.nom}},[_vm._v("\n        "+_vm._s(props.row.estat.nom)+"\n    ")]):_c('span',{attrs:{"title":props.row[props.column.field]}},[_vm._v("\n      "+_vm._s(_vm._f("truncate")(props.row[props.column.field],50))+"\n    ")])]}}])},[_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_vm._v("\n  No tens cap incidència\n  "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }